package com.patronat.top.features.venues.domain.usecase.command

import com.patronat.top.dto.CreateVenueRequest

data class CreateVenueCommand(
    val request: CreateVenueRequest
)
